module.exports = __webpack_public_path__ + "static/media/tree-view-inactive.43df8e73.svg";